import React, { useEffect, useRef, useState } from "react";

const RoadMap = () => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const tkdMarker = useRef(null);
  const kmhMarker = useRef(null);
  const flightPath = useRef(null);

  const lastUnix = useRef(null);
  const noGpsCounter = useRef(0);

  const sameLAT = useRef([]);
  const sameLON = useRef([]);
  const GPS_i = useRef(0);

  const [speed, setSpeed] = useState(0);

  const getTKD = () => new URLSearchParams(window.location.search).get("id") || " ";

  const isProd = process.env.NODE_ENV === "production";
  const url = isProd ? "api/getGPS/index.php" : "api_react_test/getGPS/";

  useEffect(() => {
    if (!kmhMarker.current) return;

    kmhMarker.current.setIcon({
      url: `img/roadmap/km/${speed}.png`,
      scaledSize: new window.google.maps.Size(78, 35),
      anchor: new window.google.maps.Point(-5, 40)
    });
  }, [speed]);

  const initMap = () => {
    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      zoom: 13,
      center: { lat: -24.2246, lng: -69.0237 },
      mapTypeId: "satellite",
      mapTypeControl: false
    });

    tkdMarker.current = new window.google.maps.Marker({
      map: mapInstance.current,
      icon: {
        url: "img/roadMap/TKDmarker_nn.png",
        scaledSize: new window.google.maps.Size(62, 83),
        anchor: new window.google.maps.Point(28, 45)
      }
    });

    kmhMarker.current = new window.google.maps.Marker({
      map: mapInstance.current,
      icon: {
        url: `img/roadmap/km/${speed}.png`,
        scaledSize: new window.google.maps.Size(78, 35),
        anchor: new window.google.maps.Point(-5, 40)
      }
    });

    flightPath.current = new window.google.maps.Polyline({
      geodesic: true,
      strokeColor: "#FF0000",
      strokeOpacity: 1.0,
      strokeWeight: 5,
      map: mapInstance.current
    });

    fetchGPS();
  };

  const fetchGPS = async () => {
    const tkd = getTKD();
    const res = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ tkd }),
      headers: { "Content-Type": "application/json" }
    });

    const json = await res.json();
    drawLine(json);
  };

  const drawLine = (json) => {
    const n = json.n;
    const coords = [];
    const latArray = [];
    const lonArray = [];

    setSpeed(Math.floor(json.data[n - 1].speed));

    for (let i = 0; i < n - 1; i++) {
      const lat = parseFloat(json.data[i].lat);
      const lon = parseFloat(json.data[i].lon);
      coords.push({ lat, lng: lon });
      latArray.push(lat);
      lonArray.push(lon);
    }

    const currentLat = latArray[0];
    const currentLon = lonArray[0];
    const currentPos = { lat: currentLat, lng: currentLon };

    sameLAT.current[GPS_i.current] = currentLat;
    sameLON.current[GPS_i.current] = currentLon;
    GPS_i.current = (GPS_i.current + 1) % 10;

    const gpsUnix = json.data[0].unix;
    if (lastUnix.current === gpsUnix) {
      noGpsCounter.current++;
    } else {
      noGpsCounter.current = 0;
      lastUnix.current = gpsUnix;
    }

    let tkdURL;
    if (noGpsCounter.current > 6) {
      flightPath.current.setOptions({ strokeColor: "#555555" });
      tkdURL = "img/roadMap/TKDmarker_gray.png";
    } else {
      flightPath.current.setOptions({ strokeColor: "#FF0000" });
      tkdURL = "img/roadMap/TKDmarker_nn.png";
    }

    tkdMarker.current.setIcon({
      url: tkdURL,
      size: new window.google.maps.Size(70, 80),
      scaledSize: new window.google.maps.Size(70, 80),
      anchor: new window.google.maps.Point(30, 40)
    });

    tkdMarker.current.setPosition(currentPos);
    kmhMarker.current.setPosition(currentPos);
    flightPath.current.setPath(coords);
    mapInstance.current.setCenter(currentPos);
  };

  useEffect(() => {
    setTimeout(initMap, 500);
    const interval = setInterval(fetchGPS, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ borderRadius: "15px", overflow: "hidden" }}>
      <div
        ref={mapRef}
        style={{
          width: "100%",
          height: "340px",
          borderRadius: "15px",
          backgroundImage: 'url("/img/roadMap/mapThumb.jpg")',
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat"
        }}
      />
    </div>
  );
};

export default RoadMap;
